import { Type } from "@sinclair/typebox";
import { ErrorCode } from "../enums";
/** Every thrown error serialises to this. plan.md §4, Routes and errors. */
export const ErrorResponseSchema = Type.Object({
    error: Type.String(),
});
/**
 * Claims from a Supabase JWT. `is_anonymous` distinguishes a guest from a
 * registered account; the admin role is not in the token and is looked up
 * against `user_profiles`.
 */
export const UserPayloadSchema = Type.Object({
    sub: Type.String(),
    email: Type.Optional(Type.String()),
    is_anonymous: Type.Optional(Type.Boolean()),
});
/** Typed error carried over the WebSocket, mirroring the HTTP status codes. */
export const SocketErrorSchema = Type.Object({
    code: Type.Enum(ErrorCode),
    message: Type.String(),
});
